import { Modal, Image, ModalContent, Button } from "semantic-ui-react"
import CloseIcon from "../../../images/close-icon.svg"
import ebayTiresSavings from "../../../images/ebay-tires-savings.svg"

const TireProtectModal = ({ open, onClose, vehicleDetails, marketingOptIn, marketingOptOut }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      className={`tire-protect-modal`}
      size="tiny"
      centered
      closeIcon
    >
      <Image src={CloseIcon} width="24px" height="24px" className="close-icon" onClick={onClose} />
      <ModalContent>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <img src={ebayTiresSavings} height="88px" width="88px" />
          <p style={{ textAlign: "center", fontWeight: "400", fontSize: "20px", color: "#3C3C3C" }}>
            Your appointment is booked! <b>Unlock 10% off your next service.</b>
          </p>
        </div>
        <p className="m-0">
          Get exclusive maintenance savings for your {vehicleDetails}. Join over 1 million drivers
          who trust CarAdvise for convenient, affordable car care.
        </p>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            marginTop: "20px"
          }}
        >
          <Button className="primary-button" primary onClick={marketingOptIn}>
            I'm in!
          </Button>
          <p style={{ margin: "5px" }} />
          <Button color="#F4F7F5" secondary onClick={marketingOptOut}>
            No thanks
          </Button>
        </div>
      </ModalContent>
    </Modal>
  )
}

export default TireProtectModal
